/*!
 * Product Page: https://www.creative-tim.com/product/now-ui-dashboard-pro-react
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)
 * Coded by Creative Tim
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
/*eslint-disable*/
import React, { Component } from 'react';
// react component for creating dynamic tables
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, CardTitle, Row, Col, Button } from 'reactstrap';
import ReactTooltip from 'react-tooltip';
import PanelHeader from 'components/PanelHeader/PanelHeader.jsx';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ReactGA from 'react-ga';

const queryString = require('query-string');

var companyId = '';

class EmployeeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            filtered: [],
            disabled: false,
        };
    }

    //we get the data from the system on this call
    componentDidMount() {
        //are we logged in?
        //yes
        if (
            localStorage.getItem('LOGGEDIN') &&
            localStorage.getItem('LOGGEDIN') === 'true' &&
            localStorage.getItem('DATEEXPIRES') &&
            new Date(localStorage.getItem('DATEEXPIRES')) > new Date()
        ) {
            ReactGA.pageview(window.location.pathname + window.location.search);

            //start it out as the default
            companyId = localStorage.getItem('companyId');

            var qs = queryString.parse(this.props.location.search);

            //do we have a company id coming in on the querystring?
            //yes
            if (qs['companyId']) {
                //set the one from the querystring
                companyId = qs['companyId'];
            }

            this.loadData();
        }
        //are we logged in?
        //no
        else {
            this.props.history.push('/a/logout');
        }
    }

    setError(error, disabled, loading) {
        this.setState({
            error,
            disabled,
            loading,
        });
    }

    loadData() {
        // GET request using fetch with error handling
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                SECRET: localStorage.getItem('SECRET'),
                PASSPHRASE: localStorage.getItem('PASSPHRASE'),
            },
        };

        fetch(window.configuration.EmployeeURL + '?companyId=' + companyId, requestOptions)
            .then(async (response) => {
                //did we get an error?
                //yes
                if (!response.ok) {
                    //did we get an unauthorized?
                    //yes
                    if (response.status === 401) {
                        this.props.history.push('/a/logout');
                    }
                    return null;
                }
                //did we get an error?
                //no
                else {
                    var employees = await response.json();

                    var qs = queryString.parse(this.props.location.search);

                    //create our rows
                    var employeeObjects = employees.map(function (employee) {
                        return {
                            id: employee.id,
                            name: employee.firstName + ' ' + employee.lastName,
                            phoneNumber: employee.phoneNumber
                                ? '(' +
                                  employee.phoneNumber.slice(0, 3) +
                                  ') ' +
                                  employee.phoneNumber.slice(3, 6) +
                                  '-' +
                                  employee.phoneNumber.slice(6, 10)
                                : '',
                            department: employee.department,
                            emailAddress: employee.emailAddress,
                            enabled: employee.enabled,
                            actions: (
                                // we've added some custom button actions
                                <div className="actions-right">
                                    <ReactTooltip />
                                    <Link
                                        to={
                                            '/in/f/employee?id=' +
                                            employee.id +
                                            '&companyId=' +
                                            companyId +
                                            '&returnAfter=' +
                                            qs['returnAfter']
                                        }
                                    >
                                        <Button
                                            data-tip="edit"
                                            className="btn-icon btn-round"
                                            color={'success'}
                                            size="sm"
                                        >
                                            <i className="fa fa-edit" />
                                        </Button>
                                    </Link>
                                    {/* spacer between buttons */ ' '}
                                    <Button
                                        data-tip={employee.enabled === true ? 'disable' : 'enable'}
                                        className="btn-icon btn-round"
                                        color={employee.enabled === true ? 'success' : 'danger'}
                                        size="sm"
                                        onClick={() => {
                                            //enable or disable it
                                            var enabled = employee.enabled ? false : true;

                                            //get the group from the server
                                            const requestOptions = {
                                                method: 'PATCH',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    SECRET: localStorage.getItem('SECRET'),
                                                    PASSPHRASE: localStorage.getItem('PASSPHRASE'),
                                                },
                                                body: JSON.stringify({
                                                    id: employee.id,
                                                    siteId: window.configuration.siteId,
                                                    companyId: employee.companyId,
                                                    enabled: enabled,
                                                }),
                                            };

                                            fetch(window.configuration.EmployeeURL, requestOptions)
                                                .then(async (response) => {
                                                    // check for error response
                                                    //did we get an error?
                                                    //yes
                                                    if (!response.ok) {
                                                        // get error message from body or default to response status
                                                        const error = response.status;
                                                        return Promise.reject(error);
                                                    }
                                                    //did we get an error?
                                                    //no
                                                    else {
                                                        window.location.reload();
                                                    }
                                                })
                                                .catch((error) => {
                                                    console.log(error);
                                                });
                                        }}
                                    >
                                        <i
                                            className={
                                                employee.enabled === true ? 'fa fa-toggle-on' : 'fa fa-toggle-off'
                                            }
                                        />
                                    </Button>
                                    {/* spacer between buttons */ ' '}
                                    <Button
                                        data-tip="remove"
                                        onClick={() => {
                                            //confirm that they want to remove it
                                            confirmAlert({
                                                closeOnEscape: true,
                                                closeOnClickOutside: true,
                                                onClickOutside: () => {},
                                                onKeypressEscape: () => {},
                                                willUnmount: () => {},
                                                afterClose: () => {},
                                                message:
                                                    'Are you sure you want to remove the employee ' +
                                                    employee.firstName +
                                                    ' ' +
                                                    employee.lastName +
                                                    '?',
                                                buttons: [
                                                    {
                                                        label: 'Yes',
                                                        onClick: () => {
                                                            // DELETE request using fetch with error handling
                                                            const requestOptions = {
                                                                method: 'DELETE',
                                                                headers: {
                                                                    'Content-Type': 'application/json',
                                                                    SECRET: localStorage.getItem('SECRET'),
                                                                    PASSPHRASE: localStorage.getItem('PASSPHRASE'),
                                                                },
                                                            };

                                                            fetch(
                                                                window.configuration.EmployeeURL +
                                                                    '?companyId=' +
                                                                    companyId +
                                                                    '&employeeId=' +
                                                                    employee.id,
                                                                requestOptions,
                                                            )
                                                                .then(async (response) => {
                                                                    // check for error response
                                                                    //did we get an error?
                                                                    //no
                                                                    if (response.ok) {
                                                                        //refresh the page
                                                                        window.location.reload();
                                                                    }
                                                                })
                                                                .catch((error) => {
                                                                    console.log(error);
                                                                });
                                                        },
                                                    },
                                                    {
                                                        label: 'No',
                                                    },
                                                ],
                                            });
                                        }}
                                        className="btn-icon btn-round"
                                        color={'danger'}
                                        size="sm"
                                    >
                                        <i className="fa fa-times" />
                                    </Button>
                                </div>
                            ),
                        };
                    });

                    //grab our response
                    this.setState({
                        data: employeeObjects,
                        loading: false,
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    error: error,
                    loading: false,
                });
                return null;
            });
    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = this.state.filtered;
        let insertNewFilter = 1;

        if (filtered.length) {
            filtered.forEach((filter, i) => {
                if (filter['id'] === accessor) {
                    if (value === '' || !value.length) filtered.splice(i, 1);
                    else filter['value'] = value;

                    insertNewFilter = 0;
                }
            });
        }

        if (insertNewFilter) {
            filtered.push({ id: accessor, value: value });
        }

        this.setState({ filtered: filtered });
    };

    render() {
        //are we loading?
        //yes
        if (this.state.loading === true) {
            return (
                <>
                    <Loader
                        height="0"
                        width="0"
                        type="ThreeDots"
                        color="#00BFFF"
                        style={{
                            position: 'fixed',
                            top: '0',
                            left: '0',
                            background: '#99CCFF',
                            opacity: '0.6',
                            zIndex: '998',
                            height: '100%',
                            width: '100%',
                        }}
                    />
                </>
            );
        }

        var qs = queryString.parse(this.props.location.search);

        return (
            <>
                {this.state.loading ? (
                    <Loader
                        height="0"
                        width="0"
                        type="ThreeDots"
                        color="#00BFFF"
                        style={{
                            position: 'fixed',
                            top: '0',
                            left: '0',
                            background: '#99CCFF',
                            opacity: '0.6',
                            zIndex: '998',
                            height: '100%',
                            width: '100%',
                        }}
                    />
                ) : (
                    ''
                )}
                <PanelHeader size="sm" />
                <div className="content">
                    <Row>
                        <Col xs={12} md={10}>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h4">Employees</CardTitle>
                                    <CardTitle>
                                        <Link
                                            style={{ color: '#1aafc4' }}
                                            to={
                                                '/in/f/employee?companyId=' +
                                                companyId +
                                                '&returnAfter=' +
                                                qs['returnAfter']
                                            }
                                        >
                                            Add a new employee
                                        </Link>
                                        <span style={{ display: qs['returnAfter'] ? '' : 'none' }}>
                                            &nbsp;or&nbsp;
                                            <Link
                                                style={{ color: '#1aafc4' }}
                                                to={qs['returnAfter'] ? qs['returnAfter'] : 'update#replyall'}
                                            >
                                                go back to companies
                                            </Link>
                                        </span>
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={this.state.data}
                                        filterable={true}
                                        filtered={this.state.filtered}
                                        onFilteredChange={(filtered, column, value) => {
                                            this.onFilteredChangeCustom(value, column.id || column.accessor);
                                        }}
                                        defaultFilterMethod={(filter, row, column) => {
                                            const id = filter.pivotId || filter.id;
                                            if (typeof filter.value === 'object') {
                                                return row[id] !== undefined
                                                    ? filter.value.indexOf(row[id]) > -1
                                                    : true;
                                            } else {
                                                return row[id] !== undefined
                                                    ? String(row[id]).indexOf(filter.value) > -1
                                                    : true;
                                            }
                                        }}
                                        columns={[
                                            {
                                                Header: 'Name',
                                                accessor: 'name',
                                                width: 300,
                                            },
                                            {
                                                Header: 'Phone Number',
                                                accessor: 'phoneNumber',
                                                width: 150,
                                            },
                                            {
                                                Header: 'Email Address',
                                                accessor: 'emailAddress',
                                                width: 350,
                                            },
                                            {
                                                Header: 'Department',
                                                accessor: 'department',
                                                width: 250,
                                            },
                                            {
                                                Header: '',
                                                accessor: 'actions',
                                                sortable: false,
                                                filterable: false,
                                            },
                                        ]}
                                        defaultPageSize={this.state.data.length}
                                        showPaginationBottom={false}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default EmployeeList;
